import { QueryClient } from '@tanstack/react-query';
import { onSignedOut } from './signOutCleanup';

/** The app's one React Query cache (App.tsx provides it). */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: 1,
    },
  },
});

// Orders, customers, finance… were loaded for the person who just left. The
// next one on this tab must not see them, not even for the 30 s staleTime.
onSignedOut(() => queryClient.clear());
